



























































































import Vue from 'vue';
import DropDown from '@/components/FormInputs/DropDown.vue';

export default Vue.extend({
  name: 'UnternehmenFilters',
  data() {
    return {
      fulltext: '',
    };
  },
  components: {
    DropDown,
  },
  methods: {
    setOrder: function(value: number): void {
      this.$store.dispatch('setOrder', value);
    },
    setFulltext() {
      this.$store.dispatch('setFulltext', this.fulltext);
    },
  },
  computed: {
    orders: function() {
      return [
        { name: 'Al­pha­be­tisch', id: 1 },
        { name: 'Empfohlen', id: 0 },
      ];
    },
    order: function() {
      return this.$store.state.order;
    },
  },
});
